// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24Bc9","productName":"Table_productName__2BGB6"};